module.exports = __webpack_public_path__ + "img/sdk-banner.2d034ae7.png";